"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardName = void 0;
const dashboardNames = ["BOLOS", "OLOS\u0000"];
const isDashboardName = (name) => dashboardNames.includes(name);
exports.isDashboardName = isDashboardName;
//# sourceMappingURL=isDashboardName.js.map